<div class="row">
    <div class="col-md-2"></div>
      <div class="col-md-8">
      <app-toast *ngFor="let toast of toasts; let i=index" 
        [toast]="toast" [i]="i"
        (remove)="remove($event)"></app-toast>
        </div><div class="col-md-2"></div>
  
  </div>
